import { useEffect } from "react";

import { PreloadedQuery } from "react-relay";

import { pricingPageRelayQuery } from "@/__generated_contentful__/pricingPageRelayQuery.graphql";
import { PricingContentContextProviderRelay } from "@/components/wpl/pricing/src/pricing-content-context";
import { NonProfitPricingPageTemplate } from "@/templates/non-profit-pricing-page/src";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content-gql.ts";

import { AppPricingData } from "../../../../contentful";
import { UserLocale } from "../../../../utils/useGeoCurrency";

import { getPricingTitleInternal } from "./feature-gates.ts";

export type NonProfitPricingPageProps = {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
    queryRef?: PreloadedQuery<pricingPageRelayQuery>;
};

export const NonProfitPricingPageRelay = ({
    pricing,
    countryCode,
    pricingContent,
    queryRef
}: NonProfitPricingPageProps) => {
    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdPricingAll);
    }, []);

    return (
        <PricingContentContextProviderRelay
            productId="nonprofit"
            pricingTitleInternal={getPricingTitleInternal()}
            pricingContent={pricingContent}
            queryRef={queryRef}
        >
            <div data-testid="non-profit-pricing">
                <NonProfitPricingPageTemplate
                    pricing={pricing}
                    countryCode={countryCode}
                />
            </div>
        </PricingContentContextProviderRelay>
    );
};
